<template>
<div class="micad_userMenu">
  <button class="micad_userMenu_control" @click="userMenuControl"></button>
  <ul class="micad_userMenu_menu">
    <li class="micad_userMenu_menu_item" v-for="item in items" :key="item.text">
        <a :href="item.href" :title="item.title" :class="['micad_userMenu_menu_item_link',item.class]">{{item.text}}</a>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: 'Notes',
  data() {
    return {
      notesTitle: "Main title",
      items: [
        {text: "Item 1", title: "Quisque tristique .", href: "http://www.micad.com"},
        {text: "Item 2", title: "Quis leo.", href: "http://www.micad.com"},
        {text: "Item 3", title: "Vitae luctus.", href: "http://www.micad.com", class: "micad_userMenu_logOut"}
      ]
    }
  },
   methods: {
    userMenuControl: function (e) {
      var obj = e.target;
      obj.parentNode.classList.toggle("micad_userMenu_selected");
    }
  }
};
</script>